"use client";

import type { CSSProperties, ReactNode } from "react";
import { useInView } from "@/hooks/useInView";

type Props = {
  children: ReactNode;
  delay?: number;
  className?: string;
};

export function ScrollReveal({ children, delay = 0, className }: Props) {
  const [ref, isInView] = useInView();
  const style: CSSProperties = {
    opacity: isInView ? 1 : 0,
    transform: isInView ? "none" : "translateY(28px)",
    transition: `opacity 0.72s cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms, transform 0.72s cubic-bezier(0.22, 1, 0.36, 1) ${delay}ms`,
  };
  return (
    <div ref={ref} className={className} style={style}>
      {children}
    </div>
  );
}
